export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '主题名称',
    field: 'name',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '主题编号',
    field: 'code'
  },
  {
    headerName: '主题分类名称',
    field: 'programCategoryName'
  },
  {
    headerName: '总人数',
    field: 'times'
  },
  {
    headerName: '参训人数',
    field: 'factCount'
  },
  {
    headerName: '参训率',
    field: 'trainingRate'
  },
  {
    headerName: '通过人数',
    field: 'passCount'
  },
  {
    headerName: '通过率',
    field: 'passRate'
  },
]